/**
 * Weight of the drawn dimension line, mirroring the stroke used by
 * ./components/DimensionArrow. It is the floor its hit area shrinks to when the user
 * zooms all the way in.
 */
export const DIMENSION_LINE_STROKE_WIDTH = 1.5;
